import { useState, useEffect } from 'react';
import styles from '@/styles/Home.module.css';

export default function InvalidLink() {
  const [errors, setErrors] = useState({
    first: '',
    second: '',
  });

  useEffect(() => {
    setErrors({
      first: window?.error?.caption ?? 'Invalid link',
      second: window?.error?.message ?? 'The link to this payment is invalid, please verify the url and try again.',
    });
  }, []);
  return (
    <>
      <div className={styles.container}>
        <div>
          <div className={styles.main}>
            <div className={styles.subwrap}>
              <img className={styles.errorimage} src="/assets/cancel.svg" />
              <div className={styles.errormessage}>{errors.first}</div>
              <div className={styles.errorbody}>{errors.second}</div>
            </div>
            <div className={styles.supportarea}>
              <span>
                Think this is an error?{' '}
                <a href={`mailto:help@squadco.com?subject=Invalid transaction error`}>Email Us</a>
              </span>
            </div>
          </div>
          <div className={styles.logo}>
            <img src="/assets/secure.svg" className={styles.brandimg} />
          </div>
        </div>
      </div>
    </>
  );
}
